export function getdata() {
	var obj = {
		searchlist: [{
				prop: "likeContent",
				label: '附加信息名称',
				type: "input"
			},

		],
		searchdata: {
			likeContent: ""
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		headData: [{
				title: "序号",
				prop: "xh",
				width: "60",
				custom: true,
			},
			{
				title: "附加信息名称",
				prop: "fujxxmc",
				width: "160",
				issort: true
			},
			{
				title: "数据类型",
				prop: "shujlx",
				width: "100",
				custom: true,
				issort: true
			},
			{
				title: "输入方式",
				prop: "shurfs",
				align: "left",
				width: "100",
				custom: true,
				issort: true
			},
			{
				title: "引用状态",
				prop: "yinyzt",
				width: "100",
				custom: true,
				issort: true
			},
			{
				title: "创建人",
				prop: "chuangjr",
				width: "100",
				issort: true
			},
			{
				title: "创建时间",
				prop: "chuangjsj",
				align: "left",
				width: "160"
			},
			{
				title: "修改人",
				prop: "xiugr",
				width: "100",
				issort: true
			},
			{
				title: "修改时间",
				prop: "xiugsj",
				align: "left",
				width: "160"
			},
			{
				title: "操作",
				prop: "cz",
				width: "100",
				custom: true,
			},
		],
		options: [{
			value: '0',
			label: '文本型'
		}, {
			value: '1',
			label: '数值型'
		}, {
			value: '2',
			label: '日期型'
		}],
	}
	return obj
}
